
import axios from 'axios'
import PartialCheckbox from './PartialCheckbox.vue'
import PieChart from './PieChart.vue'
import BaseFile from './BaseFile.vue'
import { analysePartitions } from '../services/payload_composition'
import { chromeos_update_engine as update_metadata_pb } from '../services/update_metadata_pb'
import { TooltipComponentPositionCallbackParams } from 'echarts'
import { EchartsData } from '@/services/echarts_data'
import { defineComponent } from 'vue'
import {
  downloadFile,
  ensureSuffix,
  getFileName,
  trimTargetFiles
} from '@/services/trim_zip'

interface ComponentState {
  partitionInclude: Map<string, boolean>
  echartsData: EchartsData | null
  listData: string
  targetFile: File | URL | null
}

export default defineComponent({
  components: {
    PartialCheckbox,
    PieChart,
    BaseFile
  },
  props: {
    manifest: {
      type: update_metadata_pb.DeltaArchiveManifest,
      default: () => []
    },
    demo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      partitionInclude: new Map(),
      echartsData: null,
      listData: '',
      targetFile: null
    } as ComponentState
  },
  computed: {
    updatePartitions(): string[] {
      return this.manifest.partitions.map(
        (partition: update_metadata_pb.IPartitionUpdate) => {
          return partition.partitionName
        }
      )
    }
  },
  async mounted() {
    if (this.demo) {
      try {
        const download = await axios.get(
          './files/cf_x86_target_file_demo.zip',
          { responseType: 'blob' }
        )
        this.targetFile = new File([download.data], 'target_demo.zip')
      } catch (err) {
        console.log('Please put a proper example target file in /public/files/')
      }
    }
  },
  methods: {
    piechartClick(param: TooltipComponentPositionCallbackParams) {
      console.log(param)
    },
    async updateChart(metrics: string) {
      let partitionSelected = this.manifest.partitions.filter(partition =>
        this.partitionInclude.get(partition.partitionName)
      )
      try {
        this.echartsData = await analysePartitions(
          metrics,
          partitionSelected,
          this.manifest.blockSize,
          this.targetFile as File
        )
      } catch (err) {
        alert(`Cannot be processed for the following issue: ${err}`)
      }
    },
    selectBuild(file: File | URL) {
      //TODO(lishutong) check the version of target file is same to the OTA target
      this.targetFile = file
    },
    async exportTargetFileMetadata() {
      const blob = await trimTargetFiles(this.targetFile! as File)
      const downloadNode = this.$refs['download'] as HTMLAnchorElement
      downloadFile(
        blob,
        downloadNode,
        'trimmed_' + ensureSuffix(getFileName(this.targetFile! as File), '.zip')
      )
    }
  }
})
